import { RotatingLines } from "react-loader-spinner";

import { useTheme } from "@hooks";
import { ActivityIndicatorContainer } from "./styles";
import { LoaderProps } from "./types";

export const ActivityIndicator = ({ style, radius = 20, color: colorProp }: LoaderProps) => {
  const { theme } = useTheme();

  const color = colorProp ?? theme.loader.default;

  return (
    <ActivityIndicatorContainer style={style}>
      <RotatingLines visible width={radius.toString()} strokeColor={color} />
    </ActivityIndicatorContainer>
  );
};
